(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var header, layers = [], hero = null;
  var lastY = 0, hidden = false, clear = false, ticking = false;

  function scan() {
    header = document.querySelector('sticky-header.header-wrapper');
    layers = [].slice.call(document.querySelectorAll('.cm-parallax-layer'));

    /* A hero counts only if it is the FIRST section on the page */
    var main = document.getElementById('MainContent');
    var first = main && main.querySelector('.shopify-section');
    hero = first && first.querySelector('.banner, .cm-parallax-wrap') ? first : null;

    document.body.classList.toggle('cm-overlay', !!(hero && header));
    if (header) {
      document.documentElement.style.setProperty(
        '--cm-header-h', header.offsetHeight + 'px'
      );
    }
    if (!hero) {
      document.body.classList.remove('cm-clear');
      clear = false;
    }
  }

  function frame() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (header) {
      var wantHidden = y > lastY && y > 220;
      if (wantHidden !== hidden) {
        hidden = wantHidden;
        header.classList.toggle('cm-hidden', hidden);
      }
      var wantClear = !!hero && y < hero.offsetHeight * 0.85;
      if (wantClear !== clear) {
        clear = wantClear;
        document.body.classList.toggle('cm-clear', clear);
      }
    }

    if (!reduce) {
      for (var i = 0; i < layers.length; i++) {
        var el = layers[i];
        var depth = parseFloat(el.dataset.depth || '0.35');
        var box = el.parentElement.getBoundingClientRect();
        var offset = (box.top - window.innerHeight / 2) * -depth;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      }
    }

    lastY = y;
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cm-video-pause');
    if (!btn) return;
    var vid = btn.parentElement.querySelector('video');
    if (!vid) return;
    if (vid.paused) { vid.play(); btn.textContent = 'Pause'; }
    else { vid.pause(); btn.textContent = 'Play'; }
  });
  function init() { scan(); frame(); }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { scan(); onScroll(); }, { passive: true });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  document.addEventListener('DOMContentLoaded', init);
  init();
})();